import { useState, useEffect } from 'react';
import useFetchList from 'hooks/useFetchList';
import PropTypes from 'prop-types';
import Loader from '../../../../Shared/Loader';
import Select from '../../../../FormikFields/ComplexSelect/Select';
import { useSelector } from 'react-redux';

const AccountsSelect = ({
  currentAccountUuidForPdf,
  setCurrentAccountUuidForPdf,
}) => {
  const { en: { forms } } = useSelector((state) => state.i18n);
  const [accountList, setAccountList] = useState('');

  const { items: accounts, loading: accountsLoading } = useFetchList({
    baseEndpoint: `/accounts`,
    baseParams: { fields: 'businessName' },
    canLoad: true,
  });

  useEffect(() => {
    if (accounts) {
      const parsedAccounts =
        accounts &&
        accounts.map((account) => {
          return {
            label: account.businessName,
            value: account.uuid,
          };
        });
      setCurrentAccountUuidForPdf(accounts[0].uuid);
      setAccountList(parsedAccounts);
    }
  }, [accounts]);

  return (
    <>
      {accountsLoading || !accountList ? (
        <div style={{ height: 44, display: 'flex' }}>
          <Loader fullHeight />
        </div>
      ) : (
        <Select
          dataKey="chooseAnAccount"
          filterValue={currentAccountUuidForPdf}
          columnData={{
            isFilterable: false,
            options: accountList,
          }}
          onChange={(dataKey, val) => setCurrentAccountUuidForPdf(val)}
          label={forms.chooseAnAccount}
          labelWidth={78}
          hasMenuPagination
        />
      )}
    </>
  );
};

AccountsSelect.propTypes = {
  currentAccountUuidForPdf: PropTypes.string.isRequired,
  setCurrentAccountUuidForPdf: PropTypes.func.isRequired,
};

export default AccountsSelect;
